// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/line
import { ResponsiveLine } from "@nivo/line";
import { data } from "../constants";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.

export const Chart = () => (
  <>
    <ResponsiveLine
      data={data}
      theme={{
        axis: {
          domain: {
            line: {
              stroke: "#F1F3F9",
              strokeWidth: 1
            }
          },
          legend: {
            text: {
              fontSize: 14,
              fill: "#8B8D97",
              outlineWidth: 0,
              width: 0,
              outlineColor: "transparent",
              transform: "rotate(0deg) translateX(-44px) translateY(-10px)"
            }
          },
          ticks: {
            line: {
              stroke: "#F1F3F9",
              strokeWidth: 1
            },
            text: {
              fontSize: 12,
              fill: "#8B8D97",
              outlineWidth: 0,
              outlineColor: "transparent"
            }
          }
        },
        tooltip: {
          container: {
            background: "#ffffff",
            fontSize: 12,
            padding: 24,
            boxShadow: "0px 4px 32px 0px #8D1D5A0F"
          }
        },
        grid: {
          line: {
            stroke: "#F1F3F9",
            strokeWidth: 1
          }
        }
      }}
      margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: false,
        reverse: false
      }}
      yFormat=" >-.0f"
      lineWidth={3}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 11,
        tickRotation: 0,
        legend: ""
      }}
      axisLeft={{
        tickSize: 0,
        tickPadding: 24,
        tickRotation: 0,
        legend: "Credit score",
        legendOffset: -40,
        legendPosition: "start"
      }}
      colors={["#B8B8F8", "#4646DC", "#3C3CAA", "#E6007E", "#B70064"]}
      enableGridX={false}
      enablePoints={true}
      pointSize={4}
      pointColor={{ from: "serieColor" }}
      pointBorderWidth={5}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-12}
      useMesh={true}
      enableSlices="x"
      legends={[
        {
          anchor: "bottom",
          direction: "row",
          justify: false,
          translateX: 0,
          translateY: 50,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 8,
          symbolShape: ({ x, y, fill, borderWidth, borderColor }) => (
            <rect
              x={x}
              y={y + 2}
              fill={fill}
              strokeWidth={borderWidth}
              stroke={borderColor}
              width={13}
              height={3}
              rx={2}
              style={{ pointerEvents: "none" }}
            />
          ),
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          symbolSpacing: 13,
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1
              }
            }
          ]
        }
      ]}
    />
    <div
      style={{
        position: "absolute",
        right: "110px",
        bottom: "50px",
        fontSize: "14px",
        color: "#8B8D97"
      }}
    >
      Months
    </div>
  </>
);
